import axios, { AxiosResponse } from "axios";
// import { logoutRedux } from "../redux/auth/auth.actions";
import AuthActionTypes from "../redux/auth/auth.types";
import { store } from "../redux/store";
import { ApiErrorResponse, ForbiddenError, isApiResponseError, UnauthorizedError, UnknownError } from "./response";

store.subscribe(listener);

function select(state: any) {
  return state.auth.token;
}

function listener() {
  const token = select(store.getState());
  axios.defaults.headers.common["Authorization"] = `bearer ${token}`;
}

const client = axios.create({
  baseURL: process.env.REACT_APP_REST_HOST,
  maxRedirects: 5,
});

const request = (options: any) => {
  const onSuccess = (response: AxiosResponse) => {
    return response.data;
  };

  const onError = function (error: any) :Promise<ApiErrorResponse>{
    if (error.response.status === 401) {
      store.dispatch({
        type: AuthActionTypes.LOGOUT,
      });

      return Promise.reject(UnauthorizedError);
    }

    if (error.response.status === 403) {
      return Promise.reject(ForbiddenError);
    }

    if(isApiResponseError(error.response.data)){
      return Promise.reject(error.response.data as ApiErrorResponse);
    }
    if(error.message) {
      return Promise.reject(UnknownError(error.message));
    }
    return Promise.reject(UnknownError(error.toString()));
  };
  const token = select(store.getState());

  return client({
    headers: {
      Authorization: `bearer ${token}`,
    },
    ...options,
  })
    .then(onSuccess)
    .catch(onError);
};

export default request;


function makeid(length: number) {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * 
charactersLength));
 }
 return result;
}

export const request_file = (filename: string, options: any) => {
  const onSuccess = (response: AxiosResponse) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename); //or any other extension
    document.body.appendChild(link);
    link.click();
  };

  const onError = function (error: any) :Promise<ApiErrorResponse>{
    if (error.response.status === 401) {
      store.dispatch({
        type: AuthActionTypes.LOGOUT,
      });

      return Promise.reject(UnauthorizedError);
    }

    if (error.response.status === 403) {
      return Promise.reject(ForbiddenError);
    }

    if(isApiResponseError(error.response.data)){
      return Promise.reject(error.response.data as ApiErrorResponse);
    }
    if(error.message) {
      return Promise.reject(UnknownError(error.message));
    }
    return Promise.reject(UnknownError(error.toString()));
  };
  const token = select(store.getState());

  return client({
    headers: {
      Authorization: `bearer ${token}`,
    },
    responseType:"blob",
    ...options,
  })
    .then(onSuccess)
    .catch(onError);
};